import { Controller } from "@hotwired/stimulus"

// Toggles visibility of targets named "on" and "off".
// data-controller="toggle"
// data-action="click->toggle#show" / #hide / #toggle
// data-toggle-target="on"  <- shown when active
// data-toggle-target="off" <- shown when inactive

export default class extends Controller {
  static targets = ["on", "off"]

  show() {
    this.onTargets.forEach(el => el.classList.remove("hidden"))
    this.offTargets.forEach(el => el.classList.add("hidden"))
  }

  hide() {
    this.onTargets.forEach(el => el.classList.add("hidden"))
    this.offTargets.forEach(el => el.classList.remove("hidden"))
  }

  toggle() {
    const isHidden = this.onTargets[0]?.classList.contains("hidden")
    isHidden ? this.show() : this.hide()
  }
}
